import type { BrowserWindow, ILogger, Experiments } from '@wix/thunderbolt-symbols'

export const isMobileUserAgent = (window: BrowserWindow) => {
	return /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window!.navigator.userAgent)
}

export const detectRetinaScreen = (window: BrowserWindow) => {
	if (!window || !window.devicePixelRatio || !window.innerWidth || !window.outerWidth) {
		return 0
	}

	return Math.trunc(window.devicePixelRatio * window.innerWidth) <= window.outerWidth ? 1 : 2
}

export const detectBrowserZoomDesktop = (window: BrowserWindow) => {
	if (!window) {
		return 1
	}

	const displayDPR = detectRetinaScreen(window)
	if (!displayDPR) {
		return 1
	}
	const dpr = window.devicePixelRatio

	// ignore zoom out
	if (dpr <= displayDPR) {
		return 1
	}

	return Math.round((dpr / displayDPR) * 100) / 100
}

export const detectBrowserZoomOnMobile = (window: BrowserWindow) => {
	if (!window) {
		return 1
	}

	return window.visualViewport?.scale || 1
}

export const hasBrowserZoom = (window: BrowserWindow) => {
	if (!window) {
		return false
	}

	const isMobile = isMobileUserAgent(window)
	const browserZoom = isMobile ? detectBrowserZoomOnMobile(window) : detectBrowserZoomDesktop(window)

	return browserZoom > 1 ? true : false
}
